import React, { useEffect, useRef, useState } from 'react'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { type Dayjs } from 'dayjs'

import { Icon } from '~components/icons'

import './AccessibleGrid.scss'

interface CellDateInputProps {
  value: Dayjs | null
  onChange: (value: Dayjs | null) => void
  disabled?: boolean
  autoFocus?: boolean
}

const CellDateInput: React.FC<CellDateInputProps> = ({ value, onChange, disabled, autoFocus }) => {
  const [localValue, setLocalValue] = useState<Dayjs | null>(value)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  useEffect(() => {
    if (autoFocus) {
      requestAnimationFrame(() => {
        inputRef.current?.focus()
      })
    }
  }, [autoFocus])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        value={localValue}
        onChange={setLocalValue}
        onAccept={onChange}
        disabled={disabled}
        closeOnSelect
        slots={{
          openPickerIcon: () => <Icon name='Event' />,
        }}
        slotProps={{
          textField: {
            inputRef,
            size: 'small',
            fullWidth: true,
            variant: 'standard',
            sx: {
              '& .MuiInput-underline:before, & .MuiInput-underline:after': {
                borderBottom: 'none',
              },
              '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                borderBottom: 'none',
              },
              '& .MuiInputBase-input': {
                padding: 0,
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  )
}

export default CellDateInput
